// extracted by mini-css-extract-plugin
export default {"root":"FeaturesButton__root--1EC8X","root_mobile":"FeaturesButton__root_mobile--z8m4n","informer":"FeaturesButton__informer--2VEY4"};